//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import configInfo from "../configInfo.js"
	export default{
		props:['titleShow', 'showCount','zIndexP','selectedArea','isShowHotArea'],
		data(){
			return{
				areas:[],
				zIndex:10010,
				top:55
			}
		},
		mounted(){
      this.resetzIndex();
			this.hagkHttp(this.hagkApi.getAllHotRegion(), {})
			.then((res) => {
				if(res){
					this.areas.splice(0, this.areas.length);
					for(var i=0;i<res.length;i++){
						this.areas.push(res[i]);
					}
				}
			}, (error) => {
				console.log(error);
				window.alert('热门赛区获取失败！');
			})
		},
		watch: {
			isShowHotArea: function () {
					if (this.isShowHotArea) {
						if (configInfo.isAdvertisementShow) {
							this.top = 55;
						} else {
							this.top = 55;
						}
					}
			}
    },
		methods:{
      resetzIndex(){
				
				
        if(typeof(this.zIndexP) !='undefined'){
            this.zIndex = this.zIndexP;
        }
      },
			changeRegion(orgCode, orgName){
				this.$emit('changeRegion', orgCode, orgName);
			}
		}
	}



// WEBPACK FOOTER //
// ./src/views/hotArea.vue